import type { PlainEnvironment } from "@/queries/environment-queries";

export function environmentLogsUrl(environment?: PlainEnvironment) {
    if (!environment?.status?.environmentUrls?.logs) {
        return;
    }
    // We're adding the status machine session to the URL to trigger a refresh when a new machine session starts
    // The macOS runner resets the log stream, so this ensures we clear our logs as well.
    return `${environment?.status?.environmentUrls?.logs}#${environment?.status?.machine?.session}`;
}

export function environmentLogGroupUrl(environmentId?: string, logGroupId?: string) {
    return `/details/${environmentId}/logs${logGroupId ? `#${logGroupId}` : ""}`;
}
